import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconXLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m12 13.054-5.073 5.073a.726.726 0 0 1-.522.213.708.708 0 0 1-.532-.213.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527L10.946 12 5.873 6.927a.726.726 0 0 1-.212-.522.708.708 0 0 1 .212-.532.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217L12 10.946l5.073-5.073a.726.726 0 0 1 .522-.212.708.708 0 0 1 .532.212c.145.145.217.32.217.527a.718.718 0 0 1-.217.527L13.054 12l5.073 5.073c.138.139.21.313.213.522a.707.707 0 0 1-.213.532.718.718 0 0 1-.527.217.718.718 0 0 1-.527-.217L12 13.054Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconXLine;
